// services/school-ui/src/pages/chat/attachments/types.ts
//
// Wire types matching the kernel contract pinned at nova-os#434.
// AttachmentRef is what POST /v1/conversations/{cid}/attachments
// returns and what history-load surfaces under messages[i].attachments[].
// AttachmentCapabilities is what /api/copilotkit/info?app=school's
// new capabilities.attachments object carries.

export interface AttachmentRef {
  id: string;
  name: string;
  mime_type: string;
  size_bytes: number;
  download_url: string;
  created_at: string;
  /** Soft-delete marker; if set, the chip renders in disabled
   *  "unavailable" state and the download_url should not be opened. */
  deleted_at?: string | null;
}

export interface AttachmentCapabilities {
  enabled: boolean;
  max_size_bytes: number;
  per_conversation_max: number;
  allowed_mime_types: string[];
}

/** Fallback used when /info response omits the capabilities block.
 *  enabled:false hides every attachment-related UI surface, which is
 *  the right v1 behavior against any Nova OS that hasn't shipped
 *  the #434 endpoints yet. */
export const DISABLED_CAPABILITIES: AttachmentCapabilities = {
  enabled: false,
  max_size_bytes: 0,
  per_conversation_max: 0,
  allowed_mime_types: [],
};
